
import React, { useEffect, useState } from "react";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Autoplay, Pagination } from 'swiper';
import { baseApiUrl } from "../../../services/api";

// Installer les modules
SwiperCore.use([Autoplay, Pagination]);

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';

function Domaine() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    baseApiUrl
      .get("/categorie/liste")
      .then((response) => {
        setCategories(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des catégories :", error);
        setError("Erreur lors du chargement des catégories.");
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <p>Chargement des domaine...</p>;
  }

  if (error) {
    return <p>{error}</p>;
  }

  return (
    <div className="domaines-section py-5">
      <div className="container">
        <div className="row justify-content-center mb-5">
          <div className="col-lg-6">
            <div className="heading1 text-center">
              <h2 className="text-anime-style-3">NOS DOMAINES D’INNOVATION</h2>
              <div className="divider mx-auto my-3" style={{ height: "4px", width: "60px", backgroundColor: "#F29F3D" }}></div>
            </div>
          </div>
        </div>

        {categories.length > 0 ? (
          <Swiper
            spaceBetween={30}
            slidesPerView={3}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            pagination={{
              clickable: true,
              dynamicBullets: true,
            }}
            loop={true}
            modules={[Autoplay, Pagination]}
            className="domaines-swiper"
            breakpoints={{
              1200: {
                slidesPerView: 3,
              },
              768: {
                slidesPerView: 2,
              },
              320: {
                slidesPerView: 1,
              },
            }}
          >
            {categories.map((category) => (
              <SwiperSlide key={category.id}>
                <div className="domaine-card shadow-sm rounded overflow-hidden">
                  <div className="image-wrapper" style={{ height: "200px", overflow: "hidden" }}>
                    <img
                      src={
                        category.image
                          ? baseApiUrl.defaults.baseURL +`/image/${category.image}`
                          : "default-image.jpg"
                      }
                      alt={category.titre || "Titre inconnu"}
                      className="w-100 h-100 object-cover"
                      style={{ objectFit: "cover", transition: "transform 0.3s ease" }}
                      onMouseOver={(e) => e.currentTarget.style.transform = "scale(1.05)"}
                      onMouseOut={(e) => e.currentTarget.style.transform = "scale(1)"}
                    />
                  </div>
                  <div className="card-body text-center p-4">
                    <h4 style={{ color: "#F29F3D", fontWeight: "bold" }}>
                      {category.nom}
                    </h4>
                    {category.description && (
                      <p className="mt-2 text-muted">{category.description}</p>
                    )}
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        ) : (
          <div className="alert alert-info text-center">Aucun domaine disponible pour le moment.</div>
        )}
      </div>
    </div>
  );
}

export default Domaine;
